/**
 * Generated from FreePlayLayout.fla
 */
export function FreePlayLayout(this: IFreePlayLayout) {
	const main = this.main;
	FreePlayLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function FreePlayLayout_main(this: IFreePlayLayout_main) {
	const board = this.board;
	FreePlayLayout_board.call(this.board);
	board.x = 0;
	board.y = 0;
	if (board.onLayout) board.onLayout();
	const luna = this.luna;
	FreePlayLayout_luna.call(this.luna);
	luna.x = 786.9;
	luna.y = 853.05;
	luna.width = 479.32;
	luna.height = 491.19;
	if (luna.onLayout) luna.onLayout();
	const buttonComplete = this.buttonComplete;
	FreePlayLayout_buttonHomeGreen.call(this.buttonComplete);
	buttonComplete.x = -190.75;
	buttonComplete.y = 406.5;
	buttonComplete.width = 346.45;
	buttonComplete.height = 357.00;
	if (buttonComplete.onLayout) buttonComplete.onLayout();
	const buttonContinue = this.buttonContinue;
	FreePlayLayout_buttonContinue.call(this.buttonContinue);
	buttonContinue.x = 187.5;
	buttonContinue.y = 406.5;
	buttonContinue.width = 349.00;
	buttonContinue.height = 357.00;
	if (buttonContinue.onLayout) buttonContinue.onLayout();
	const burstArea = this.burstArea;
	FreePlayLayout_burstArea.call(this.burstArea);
	burstArea.x = -697.15;
	burstArea.y = -527.15;
	burstArea.width = 1394.30;
	burstArea.height = 681.65;
	if (burstArea.onLayout) burstArea.onLayout();
	const hatMask = this.hatMask;
	hatMask.push(1023.15,-760.00,-1017.20,-762.90,-1023.00,571.40,351.50,562.65,358.05,570.75,368.20,575.25,380.55,578.10,394.70,578.85,408.85,578.60,424.05,575.25,434.20,570.75,440.75,565.85,443.30,562.50,1024.00,562.10);
	const cardInHat = this.cardInHat;
	FreePlayLayout_cards0.call(this.cardInHat);
	cardInHat.x = 403.9;
	cardInHat.y = 619.25;
	cardInHat.width = 55.88;
	cardInHat.height = 70.23;
	if (cardInHat.onLayout) cardInHat.onLayout();
	const sparklePosition = this.sparklePosition;
	FreePlayLayout_sparklePosition.call(this.sparklePosition);
	sparklePosition.x = 397.45;
	sparklePosition.y = 560.4;
	sparklePosition.width = 20.00;
	sparklePosition.height = 20.00;
	if (sparklePosition.onLayout) sparklePosition.onLayout();
	return this;
}
function FreePlayLayout_board(this: IFreePlayLayout_board) {
	const cards = this.cards;
	if (!cards[0] && cards.elementFactory) {
		cards[0] = cards.elementFactory(0,undefined);
	}
	if (cards[0]) {
		FreePlayLayout_cards0.call(cards[0] as IFreePlayLayout_cards0);
		cards[0].x = -416.4;
		cards[0].y = -561.6;
		cards[0].width = 259.20;
		cards[0].height = 325.80;
		if (cards[0].onLayout) cards[0].onLayout();
	}
	if (!cards[1] && cards.elementFactory) {
		cards[1] = cards.elementFactory(1,undefined);
	}
	if (cards[1]) {
		FreePlayLayout_cards0.call(cards[1] as IFreePlayLayout_cards0);
		cards[1].x = -138.6;
		cards[1].y = -561.6;
		cards[1].width = 259.20;
		cards[1].height = 325.80;
		if (cards[1].onLayout) cards[1].onLayout();
	}
	if (!cards[2] && cards.elementFactory) {
		cards[2] = cards.elementFactory(2,undefined);
	}
	if (cards[2]) {
		FreePlayLayout_cards0.call(cards[2] as IFreePlayLayout_cards0);
		cards[2].x = 139.2;
		cards[2].y = -561.6;
		cards[2].width = 259.20;
		cards[2].height = 325.80;
		if (cards[2].onLayout) cards[2].onLayout();
	}
	if (!cards[3] && cards.elementFactory) {
		cards[3] = cards.elementFactory(3,undefined);
	}
	if (cards[3]) {
		FreePlayLayout_cards0.call(cards[3] as IFreePlayLayout_cards0);
		cards[3].x = 417.05;
		cards[3].y = -561.6;
		cards[3].width = 259.20;
		cards[3].height = 325.80;
		if (cards[3].onLayout) cards[3].onLayout();
	}
	if (!cards[4] && cards.elementFactory) {
		cards[4] = cards.elementFactory(4,undefined);
	}
	if (cards[4]) {
		FreePlayLayout_cards0.call(cards[4] as IFreePlayLayout_cards0);
		cards[4].x = -416.4;
		cards[4].y = -220.95;
		cards[4].width = 259.20;
		cards[4].height = 325.80;
		if (cards[4].onLayout) cards[4].onLayout();
	}
	if (!cards[5] && cards.elementFactory) {
		cards[5] = cards.elementFactory(5,undefined);
	}
	if (cards[5]) {
		FreePlayLayout_cards0.call(cards[5] as IFreePlayLayout_cards0);
		cards[5].x = -138.6;
		cards[5].y = -220.95;
		cards[5].width = 259.20;
		cards[5].height = 325.80;
		if (cards[5].onLayout) cards[5].onLayout();
	}
	if (!cards[6] && cards.elementFactory) {
		cards[6] = cards.elementFactory(6,undefined);
	}
	if (cards[6]) {
		FreePlayLayout_cards0.call(cards[6] as IFreePlayLayout_cards0);
		cards[6].x = 139.2;
		cards[6].y = -220.95;
		cards[6].width = 259.20;
		cards[6].height = 325.80;
		if (cards[6].onLayout) cards[6].onLayout();
	}
	if (!cards[7] && cards.elementFactory) {
		cards[7] = cards.elementFactory(7,undefined);
	}
	if (cards[7]) {
		FreePlayLayout_cards0.call(cards[7] as IFreePlayLayout_cards0);
		cards[7].x = 417.05;
		cards[7].y = -220.95;
		cards[7].width = 259.20;
		cards[7].height = 325.80;
		if (cards[7].onLayout) cards[7].onLayout();
	}
	if (!cards[8] && cards.elementFactory) {
		cards[8] = cards.elementFactory(8,undefined);
	}
	if (cards[8]) {
		FreePlayLayout_cards0.call(cards[8] as IFreePlayLayout_cards0);
		cards[8].x = -416.4;
		cards[8].y = 119.7;
		cards[8].width = 259.20;
		cards[8].height = 325.80;
		if (cards[8].onLayout) cards[8].onLayout();
	}
	if (!cards[9] && cards.elementFactory) {
		cards[9] = cards.elementFactory(9,undefined);
	}
	if (cards[9]) {
		FreePlayLayout_cards0.call(cards[9] as IFreePlayLayout_cards0);
		cards[9].x = -138.6;
		cards[9].y = 119.7;
		cards[9].width = 259.20;
		cards[9].height = 325.80;
		if (cards[9].onLayout) cards[9].onLayout();
	}
	if (!cards[10] && cards.elementFactory) {
		cards[10] = cards.elementFactory(10,undefined);
	}
	if (cards[10]) {
		FreePlayLayout_cards0.call(cards[10] as IFreePlayLayout_cards0);
		cards[10].x = 139.2;
		cards[10].y = 119.7;
		cards[10].width = 259.20;
		cards[10].height = 325.80;
		if (cards[10].onLayout) cards[10].onLayout();
	}
	if (!cards[11] && cards.elementFactory) {
		cards[11] = cards.elementFactory(11,undefined);
	}
	if (cards[11]) {
		FreePlayLayout_cards0.call(cards[11] as IFreePlayLayout_cards0);
		cards[11].x = 417.05;
		cards[11].y = 119.7;
		cards[11].width = 259.20;
		cards[11].height = 325.80;
		if (cards[11].onLayout) cards[11].onLayout();
	}
	if (!cards[12] && cards.elementFactory) {
		cards[12] = cards.elementFactory(12,undefined);
	}
	if (cards[12]) {
		FreePlayLayout_cards0.call(cards[12] as IFreePlayLayout_cards0);
		cards[12].x = -416.4;
		cards[12].y = 460.35;
		cards[12].width = 259.20;
		cards[12].height = 325.80;
		if (cards[12].onLayout) cards[12].onLayout();
	}
	if (!cards[13] && cards.elementFactory) {
		cards[13] = cards.elementFactory(13,undefined);
	}
	if (cards[13]) {
		FreePlayLayout_cards0.call(cards[13] as IFreePlayLayout_cards0);
		cards[13].x = -138.6;
		cards[13].y = 460.35;
		cards[13].width = 259.20;
		cards[13].height = 325.80;
		if (cards[13].onLayout) cards[13].onLayout();
	}
	if (!cards[14] && cards.elementFactory) {
		cards[14] = cards.elementFactory(14,undefined);
	}
	if (cards[14]) {
		FreePlayLayout_cards0.call(cards[14] as IFreePlayLayout_cards0);
		cards[14].x = 139.2;
		cards[14].y = 460.35;
		cards[14].width = 259.20;
		cards[14].height = 325.80;
		if (cards[14].onLayout) cards[14].onLayout();
	}
	if (!cards[15] && cards.elementFactory) {
		cards[15] = cards.elementFactory(15,undefined);
	}
	if (cards[15]) {
		FreePlayLayout_cards0.call(cards[15] as IFreePlayLayout_cards0);
		cards[15].x = 417.05;
		cards[15].y = 460.35;
		cards[15].width = 259.20;
		cards[15].height = 325.80;
		if (cards[15].onLayout) cards[15].onLayout();
	}
	return this;
}
function FreePlayLayout_cards0(this: IFreePlayLayout_cards0) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-free-play-back.png", 0.502, 0.500);
	return this;
}
function FreePlayLayout_luna(this: IFreePlayLayout_luna) {
	if (this.setLayoutTexture) this.setLayoutTexture("luna.png", 0.420, 1.000);
	return this;
}
function FreePlayLayout_buttonHomeGreen(this: IFreePlayLayout_buttonHomeGreen) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-home-green.png", 0.500, 0.500);
	return this;
}
function FreePlayLayout_buttonContinue(this: IFreePlayLayout_buttonContinue) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-continue.png", 0.500, 0.500);
	return this;
}
function FreePlayLayout_burstArea(this: IFreePlayLayout_burstArea) {
	return this;
}
function FreePlayLayout_hatMask(this: IFreePlayLayout_hatMask) {
	return this;
}
function FreePlayLayout_sparklePosition(this: IFreePlayLayout_sparklePosition) {
	return this;
}
interface IFreePlayLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IFreePlayLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IFreePlayLayoutSprite extends IFreePlayLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IFreePlayLayoutText extends IFreePlayLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IFreePlayLayoutPolygon extends Array<number> {
}
interface IFreePlayLayout {
	readonly main: IFreePlayLayout_main;
}
interface IFreePlayLayout_main extends IFreePlayLayoutContainer {
	readonly board: IFreePlayLayout_board;
	readonly luna: IFreePlayLayout_luna;
	readonly buttonComplete: IFreePlayLayout_buttonHomeGreen;
	readonly buttonContinue: IFreePlayLayout_buttonContinue;
	readonly burstArea: IFreePlayLayout_burstArea;
	readonly hatMask: IFreePlayLayout_hatMask;
	readonly cardInHat: IFreePlayLayout_cards0;
	readonly sparklePosition: IFreePlayLayout_sparklePosition;
}
interface IFreePlayLayout_board extends IFreePlayLayoutContainer {
	readonly cards: IFreePlayLayoutArray<IFreePlayLayout_cards0>;
}
interface IFreePlayLayout_cards0 extends IFreePlayLayoutSprite {
}
interface IFreePlayLayout_luna extends IFreePlayLayoutSprite {
}
interface IFreePlayLayout_buttonHomeGreen extends IFreePlayLayoutSprite {
}
interface IFreePlayLayout_buttonContinue extends IFreePlayLayoutSprite {
}
interface IFreePlayLayout_burstArea extends IFreePlayLayoutContainer {
}
interface IFreePlayLayout_hatMask extends IFreePlayLayoutPolygon {
}
interface IFreePlayLayout_sparklePosition extends IFreePlayLayoutContainer {
}
